import { render } from "./MediaContainer.vue?vue&type=template&id=2ed6d307"
import script from "./MediaContainer.vue?vue&type=script&lang=js"
export * from "./MediaContainer.vue?vue&type=script&lang=js"

import "./MediaContainer.vue?vue&type=style&index=0&id=2ed6d307&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__